(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["article-template"]) return;
  try {
    
    $(document).on('click', '.article-template .article-img.has-video-content .play', function() {
      var alt = $(this).prev().attr('alt');
      console.log(alt);
      if (alt && alt != '') {
        $.magnificPopup.open({
          items: [
            {
              src: alt
            }
          ],
          type: 'iframe',
          tLoading: 'Loading video...',
          mainClass: 'mfp-img-gallery',
          fixedContentPos: true,
          iframe: {
            markup: '<div class="mfp-iframe-scaler">'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                    '</div>',
            tError: 'The video could not be loaded.',
          }
        });
      }
    })    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-product-column-widget"] && !window.DesignMode) return;
  try {
    
  $(document).on('ready', function() {
    var slick_slider = $('.gp-product-column-widget .slick-product-column');
    $(".slick-product-column .slick-slide:not(.slick-active)" ).removeClass('is-slick-active');
    slick_slider.find('.slick-active').last().addClass('is-slick-active');
    slick_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $(this).find('.slick-active').removeClass('is-slick-active');
    });
    slick_slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
      $(this).find('.slick-active').last().addClass('is-slick-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-content"]) return;
  try {
    
  $(document).ready(function() {
    if ($('.password-page').length > 0) {
      function initCountdown(countdown) {
        var year = parseInt(countdown.data('year'));
        var month = parseInt(countdown.data('month')) - 1;
        var day = parseInt(countdown.data('day'));
        var newDate = new Date(year, month, day );

        var textDay = countdown.data('text-day');
        var textHour = countdown.data('text-hour');
        var textMin = countdown.data('text-min');
        var textSec = countdown.data('text-sec');
        countdown.countdown(newDate, function(event) {
          $(this).html(
            event.strftime('<div><span class="number">%D</span><span class="text">'+ textDay +'</span></div><div><span class="number">%H</span><span class="text">'+ textHour +'</span></div><div><span class="number">%M</span><span class="text">'+ textMin +'</span></div><div><span class="number">%S</span><span class="text">'+ textSec +'</span></div>')
          );
        });
      }
    }
    initCountdown($('.password-page .countdown'))
  }); 

  } catch(e) { console.error(e); }
})();

})();
